import React, { Component } from 'react';
import store from 'store';
import './css/ruler.scss';
import { VIEW } from '../config';

export default class Ruler extends Component {
  constructor() {
    super();
    this.state = {
      bottom: '50%',
      right: '50%',
      display: '',
      RWD: 'PC',
    };
  }

  updateRulerTag = () => {
    const { mesh, scene, mode, type } = this.props;
    const { viewerCameraController } = scene;
    let currentPanoId = this.getCurrentPanoId();

    const { viewVariable } = store.getState();

    const sreenCoordinate = mesh.getScreenPosition(viewerCameraController);

    let scale = 50,
      offset = 50;
    switch (mode) {
      case VIEW.SINGLE:
        scale = 100;
        offset = 0;
        break;
    }
    if (
      currentPanoId === mesh.roomId &&
      sreenCoordinate.x > 0 &&
      sreenCoordinate.x < 1 &&
      sreenCoordinate.y > 0 &&
      sreenCoordinate.y < 1 &&
      sreenCoordinate.z < 1.0 &&
      sreenCoordinate.z > -1.0 &&
      viewVariable.isDrawingRuler &&
      !viewVariable.isCameraMoving
    ) {
      if (type === 'Mobile') {
        const screenX = 2 + (1 - sreenCoordinate.x) * 100;
        let screenY;
        if (mode === VIEW.SINGLE) {
          screenY = 2 + (1 - sreenCoordinate.y) * scale + offset;
        } else {
          screenY = 2 + (1 - sreenCoordinate.y) * scale;
        }
        this.updatePosition(screenX, screenY);

      } else {
        const screenX = 1.5 + (1 - sreenCoordinate.x) * scale + offset;
        const screenY = 1.5 + (1 - sreenCoordinate.y) * 100;
        this.updatePosition(screenX, screenY);
      }
    } else {
      this.hide();
    }
  };

  getCurrentPanoId () {
    let currentPanoId = '';
    const { scene } = this.props;
    const { movingController } = scene;
    if (movingController.destinationHotspot) {
      currentPanoId = movingController.destinationHotspot.mainRoomId;
    }
    return currentPanoId;
  }

  componentDidMount () {
    // const { mesh, scene } = this.props;
    const { mesh , removeCU2 } = this.props;
    //this.length = (mesh.length * 160).toFixed(2).toString() + 'cm';
    // this.length = Math.round(mesh.length * 160).toString() + 'cm';
    
    // [Note]: Remove CU2 flag
    if(removeCU2 == true)  this.length = mesh.length.toFixed(1).toString() + 'm';
    else this.length = (Math.round(mesh.length * this.props.cameraHeight) / 100).toFixed(1).toString() + 'm';
    
    mesh.onAfterRender = this.updateRulerTag;
    this.hide();

    this.unsubscribe = store.subscribe(this.updateRulerTag);
  }

  componentWillUnmount () {
    this.unsubscribe();
    const { mesh } = this.props;
    mesh.onAfterRender = () => { };
    mesh.setVisible(false);
  }

  updatePosition = (left, top) => {
    this.setState({
      right: `${left.toString()}%`,
      bottom: `${top.toString()}%`,
      display: '',
    });
  };

  hide () {
    if (this.state.display != 'none') {
      this.setState({
        display: 'none',
      });
    }
  }

  render () {
    return (
      <div className="ruler" style={this.state}>
        {this.length}
      </div>
    );
  }
}
